import { DrawerObject } from '../../../../components/drawer/drawer.types';
import { FormBuilderComponent } from '../../../../components/form-builder/form-builder.component';
import { DynamicForm } from '../../../../components/form-builder/form-builder.types';
import { AddressRepository } from '../../../../store/address-state/address-state.repository';

interface getAddressAddDrawerObjectProps {
  store?: AddressRepository;
  formObject?: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getAddressUpdateDrawerObject = ({ store, formObject, toggleVisibility, action }: getAddressAddDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.address.update.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: formObject,
      },
    },
    actions: [
      {
        label: 'Modifier',
        onClick: () => action?.(),
      },
      {
        label: 'Annuler',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
